/* eslint-disable react/forbid-elements */
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function renderGroupIcon(name) {
  //в мобильном сайте проблема с загрузкой свг, задаваемых в css фоном
  switch (name) {
    case 'cities':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "nonzero",
          d: "M15.2 13.6v-8H12V0H5.6v4H.8v9.6H0V16h16v-2.4h-.8zM4 13.6H2.4V12H4v1.6zm0-3.2H2.4V8.8H4v1.6zm0-3.2H2.4V5.6H4v1.6zm6.4 6.4H7.2v-2.4h3.2v2.4zm0-4.8H7.2V6.4h3.2v2.4zm0-4.8H7.2V1.6h3.2V4z"
        })
      });
    case 'districts':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "13",
        viewBox: "0 0 17 13",
        children: /*#__PURE__*/_jsxs("g", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          children: [/*#__PURE__*/_jsx("path", {
            fillRule: "nonzero",
            d: "M13.68 3c1.592.354 2.774 1.696 2.774 3.3 0 2.545-3.61 6.3-3.61 6.3s-.82-.852-1.677-2.02c1.324-1.935 2.661-4.376 2.661-6.344 0-.426-.051-.84-.149-1.236zm-7.693 7.58A22.223 22.223 0 0 1 4.31 12.6S.7 8.845.7 6.3C.7 4.697 1.882 3.355 3.474 3c-.097.396-.148.81-.148 1.236 0 1.968 1.337 4.409 2.661 6.345z"
          }), /*#__PURE__*/_jsx("path", {
            d: "M8.595 0C6.055 0 4 2.003 4 4.48c0 3.36 4.595 8.32 4.595 8.32s4.595-4.96 4.595-8.32C13.19 2.003 11.135 0 8.595 0zm0 6.08c-.906 0-1.641-.717-1.641-1.6 0-.883.735-1.6 1.64-1.6.907 0 1.642.717 1.642 1.6 0 .883-.735 1.6-1.641 1.6z"
          })]
        })
      });
    case 'newbuildings':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "12",
        viewBox: "0 0 17 12",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          d: "M11.485 3V.485h3V6l2.485 2.485-2.828 2.828-5.87-5.87-5.657 5.658L0 8.485 8.485 0l3 3z"
        })
      });
    case 'shoppingCenters':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "nonzero",
          d: "M14.016 13.067c0 .782-.458 1.487-1.16 1.786a1.839 1.839 0 0 1-2.046-.42 1.974 1.974 0 0 1-.406-2.107 1.878 1.878 0 0 1 1.737-1.191c1.036.001 1.875.866 1.875 1.932zM6.22 11.135a1.878 1.878 0 0 0-1.736 1.191 1.974 1.974 0 0 0 .405 2.107c.537.553 1.345.72 2.047.42a1.934 1.934 0 0 0 1.16-1.786c-.002-1.065-.84-1.93-1.876-1.932zm9.751-7.944l-.97 3.304a.506.506 0 0 1-.385.358L5.07 8.726l.093.41h8.395c.277 0 .5.23.5.514a.508.508 0 0 1-.5.515H4.763a.503.503 0 0 1-.488-.4L2.34 1.03H.5C.224 1.03 0 .8 0 .515 0 .23.224 0 .5 0h2.25c.234 0 .436.167.488.401l.47 2.126H15.5c.158 0 .307.078.4.208.095.131.123.3.078.456h-.008z"
        })
      });
    case 'businessCenters':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          d: "M0 12h3v-1H0V8h3V7H0V4h3V3H0V0h7v5h8v10H0v-3zm7-5v2h2V7H7zm4 0v2h2V7h-2zm-4 4v2h2v-2H7zm4 0v2h2v-2h-2z"
        })
      });
    case 'undergrounds':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "11",
        viewBox: "0 0 16 11",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          d: "M8 5.907L11.111 0l4 9.574H16V11h-5.556V9.574h.89l-.89-3.055L8 9.574 5.556 6.52l-.89 3.055h.89V11H0V9.574h.889l4-9.574L8 5.907z"
        })
      });
    case 'railways':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/_jsxs("g", {
          fill: "none",
          fillRule: "nonzero",
          children: [/*#__PURE__*/_jsx("path", {
            fill: "#FFF",
            fillOpacity: ".01",
            d: "M0 0h16v16H0z"
          }), /*#__PURE__*/_jsx("path", {
            fill: "#757575",
            fillOpacity: ".54",
            d: "M11.429 12.571L12.57 16H11.43l-1.143-3.429H5.714L4.571 16H3.43l1.142-3.429H3.55a1.143 1.143 0 0 1-1.138-1.256l.915-9.143c.058-.584.55-1.03 1.137-1.03H6.02a2.285 2.285 0 0 1 3.96 0h1.557c.587 0 1.079.446 1.137 1.03l.915 9.143a1.143 1.143 0 0 1-1.138 1.256H11.43zM4.57 2.286v4.571h6.858V2.286H4.57zm0 6.857v1.143h1.143V9.143H4.571zm5.715 0v1.143h1.143V9.143h-1.143z"
          })]
        })
      });
    case 'villages':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "13",
        viewBox: "0 0 14 13",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          d: "M9.059 13h1.647c.494 0 .823-.325.823-.813V6.5h.824c.247 0 .494-.081.659-.244.33-.325.247-.812-.083-1.137L7.165.244a.875.875 0 0 0-1.07 0L.328 5.119C0 5.444-.082 5.93.247 6.256c.082.163.33.244.577.244h.823v5.688c0 .487.33.812.824.812h1.647c.494 0 .823-.325.823-.813V9.75h3.294v2.438c0 .487.33.812.824.812z"
        })
      });
    case 'roads':
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          d: "M7.758 0h1.939l.97 4.848H8.242L7.758 0zm-.97 0l-.485 4.848H3.879L4.849 0h1.939zM3.394 7.273h2.909l-.485 6.303H1.94l1.455-6.303zm7.758 0l1.454 6.303H8.727l-.485-6.303h2.91zM0 5.333h14.545v1.455h-.97v1.454h-1.454V6.788H2.424v1.454H.97V6.788H0V5.333z"
        })
      });
    case 'coworkings':
      return /*#__PURE__*/_jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.36092 1C5.12504 1 4.18496 2.10973 4.38813 3.3288L5 7H11L11.6119 3.3288C11.815 2.10973 10.875 1 9.63908 1H6.36092ZM3 11H4H7V13H4L4 15H7H9H12V13H9V11H12H13H14V7C14 6.44772 13.5523 6 13 6C12.4477 6 12 6.44772 12 7V9H4V7C4 6.44772 3.55228 6 3 6C2.44772 6 2 6.44772 2 7V11H3Z"
        })
      });
    case 'regionalDistricts':
      return /*#__PURE__*/_jsxs("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M15 13.5858V2.91436L9.66429 8.25008L15 13.5858Z",
          fill: "#C9C9C9"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.0859 1H2.41421L8.25008 6.83586L14.0859 1Z",
          fill: "#C9C9C9"
        }), /*#__PURE__*/_jsx("path", {
          d: "M1 2.41421V9.22682L4.5544 5.96862L1 2.41421Z",
          fill: "#C9C9C9"
        }), /*#__PURE__*/_jsx("path", {
          d: "M1 11.94V15H4.08594L8.83578 10.2502L5.96987 7.38424L1 11.94Z",
          fill: "#C9C9C9"
        }), /*#__PURE__*/_jsx("path", {
          d: "M6.91436 15L10.25 11.6644L13.5857 15H6.91436Z",
          fill: "#C9C9C9"
        })]
      });
    case 'addresses':
    default:
      return /*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "17",
        viewBox: "0 0 12 17",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#C9C9C9",
          fillRule: "evenodd",
          d: "M5.833 0A5.83 5.83 0 0 0 0 5.833c0 4.375 5.833 10.834 5.833 10.834s5.834-6.459 5.834-10.834A5.83 5.83 0 0 0 5.833 0zm0 7.917a2.084 2.084 0 1 1 .002-4.169 2.084 2.084 0 0 1-.002 4.169z"
        })
      });
  }
}